import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter({customer_id, agro_exporter_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/new_inspect/agro_exporter/${customer_id}/${agro_exporter_id}`
    );
  },
  fetchContainer({customer_id, agro_exporter_id, container_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/new_inspect/container/${customer_id}/${agro_exporter_id}/${container_id}`
    );
  },
  fetchTemplate({customer_id, agro_exporter_id, container_id, exporter_process_quality_template_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/new_inspect/quality_template/${customer_id}/${agro_exporter_id}/${container_id}/${exporter_process_quality_template_id}`
    );
  },
  fetchInspect({customer_id, agro_exporter_id, container_id, exporter_process_quality_template_id, quality_inspect_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/new_inspect/quality_inspect/${customer_id}/${agro_exporter_id}/${container_id}/${exporter_process_quality_template_id}/${quality_inspect_id}`
    );
  },
  fetchExportedBatches({customer_id, container_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/new_inspect/exported_batches/${customer_id}/${container_id}`
    );
  },
  destroy({ container_id, quality_inspect_id }) {
    return RequesterV1.delete(
      `customer/quality_control/destination/new_inspect/${container_id}/${quality_inspect_id}/destroy`
    );
  },
  createWithSamplings({
    container_id,
    exporter_process_quality_template_id,
    registered_at,
    exported_batch_id,
    samplings,
    quality_samplings,
  }) {
    return RequesterV1.post(
      `customer/quality_control/destination/new_inspect/create_with_samplings/${container_id}/${exporter_process_quality_template_id}`,
      {
        quality_inspect: {
          registered_at,
          samplings,
        },
        exported_batch_id,
        quality_samplings
      }
    );
  },
  createWithoutSamplings({
    container_id,
    exporter_process_quality_template_id,
    registered_at,
    exported_batch_id,
    quality_generals,
  }) {
    return RequesterV1.post(
      `customer/quality_control/destination/new_inspect/create_without_samplings/${container_id}/${exporter_process_quality_template_id}`,
      {
        quality_inspect: {
          registered_at,
        },
        exported_batch_id,
        quality_generals
      }
    );
  },
};
